import preloadImages from '../lib/preloadImages';
import { cdnUrl, imagesBucketUrl } from './env';

export const CDNFitOption = Object.freeze({
  contain: 'contain',
  cover: 'cover',
  fill: 'fill',
  inside: 'inside',
  outside: 'outside',
});

export default function getUrlFromCdn(url, { width, height } = {}) {
  if (!url) return url;

  const params = new URLSearchParams();

  if (width) params.append('width', width);
  if (height) params.append('height', height);

  return `${url.replace(imagesBucketUrl, cdnUrl)}${
    params.toString() === '' ? '' : '?'
  }${params.toString()}`;
}

export function generateSrcSetUrls({ url, width, height }) {
  return {
    '1x': `${url}?width=${width}&height=${height}`,
    '2x': `${url}?width=${width * 2}&height=${height * 2}`,
  };
}

export function generateSrcSet({ url, width, height }) {
  const urls = generateSrcSetUrls({ url, width, height });
  return Object.keys(urls)
    .reduce((prev, key) => {
      prev += `${urls[key]} ${key},`;
      return prev;
    }, '')
    .slice(0, -1);
}

export function getImageSrcAndSrcSet({ url, width, height, isPreview = false }) {
  if (url == null) return;

  const src = getUrlFromCdn(url, {
    width,
    height,
  });

  const originalSrc = src.split('?')[0];

  if (isPreview) {
    const urls = generateSrcSetUrls({ url: originalSrc, width, height });
    preloadImages({ urls: Object.values(urls) }).catch(err => console.error(err));
  }

  return {
    src,
    srcSet: generateSrcSet({
      url: originalSrc,
      width,
      height,
    }),
  };
}
